<template>
  <svg
    class="loading-spinner"
    :class="classes"
    role="status"
    aria-label="Loading"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g transform="translate(1 1)" fill-rule="nonzero">
      <circle cx="11" cy="11" r="11" fill="none"></circle>
      <path
        fill="currentColor"
        d="M10.998 22a.846.846 0 0 1 0-1.692 9.308 9.308 0 0 0 0-18.616 9.286 9.286 0 0 0-7.205 3.416.846.846 0 1 1-1.31-1.072A10.978 10.978 0 0 1 10.998 0c6.075 0 11 4.925 11 11s-4.925 11-11 11z"
      ></path>
    </g>
  </svg>
</template>

<script setup>
import { computed } from 'vue'
import { iconSizeClasses } from './common'

const props = defineProps({
  size: {
    type: String,
    default: 'sm',
  },
  color: {
    type: String,
    default: 'text-gray-700',
  },
})

const sizeClasses = computed(() => iconSizeClasses(props.size))

const classes = computed(() => [sizeClasses.value, props.color].join(' '))
</script>

<style scoped>
.loading-spinner {
  transform-origin: 50% 50%;
  will-change: transform;
  animation:
    loading-spinner-fade 250ms ease,
    loading-spinner-rotate 0.7s linear infinite;
}

@keyframes loading-spinner-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes loading-spinner-rotate {
  from {
    transform: rotateZ(0);
  }
  to {
    transform: rotateZ(360deg);
  }
}
</style>
